import I18n from 'I18n';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { RemoveIcon } from 'foundations-assets';
import { TimeInput } from 'foundations-components/transitional/components/TimeInput';
import { MultiColumn, MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { fromMoment } from 'foundations-components/transitional/utils/SimpleDate';
import { DateInput } from 'foundations-components/transitional/components/DateInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SchedulingPublishControls = ({
  scheduledPublishDate,
  setPublishDateDay,
  publishDateTime,
  setPublishDateTime,
  isReadOnlyMode,
  allowBackdating,
  maxPublishDate,
  onExitSchedulingClick
}) => {
  return /*#__PURE__*/_jsx(MultiColumn, {
    flush: true,
    children: /*#__PURE__*/_jsxs(MultiColumnGroup, {
      children: [/*#__PURE__*/_jsx(MultiColumnItem, {
        horizontalAlign: "left",
        verticalAlign: "middle",
        paddingInline: "200",
        children: /*#__PURE__*/_jsx(DateInput, {
          "data-test-id": "publishing-date-picker",
          max: maxPublishDate,
          min: allowBackdating ? undefined : fromMoment(I18n.moment.portalTz()),
          onChange: ({
            target: {
              value
            }
          }) => {
            setPublishDateDay(value);
          },
          value: scheduledPublishDate,
          readOnly: isReadOnlyMode
        })
      }), /*#__PURE__*/_jsx(MultiColumnItem, {
        horizontalAlign: "left",
        verticalAlign: "middle",
        paddingInline: "200",
        children: /*#__PURE__*/_jsx(TimeInput, {
          value: publishDateTime,
          "data-test-id": "publishing-time-picker",
          use: "default",
          onChange: e => {
            setPublishDateTime(e.target.value);
          },
          readOnly: isReadOnlyMode,
          format: `LT [${I18n.moment.portalTz().format('z')}]`,
          interval: 15
        })
      }), /*#__PURE__*/_jsx(MultiColumnItem, {
        horizontalAlign: "right",
        verticalAlign: "middle",
        paddingInline: "200",
        children: /*#__PURE__*/_jsx(IconButton, {
          use: "unstyled",
          onClick: onExitSchedulingClick,
          children: /*#__PURE__*/_jsx(RemoveIcon, {})
        })
      })]
    })
  });
};
export default SchedulingPublishControls;